import { Tile } from "./tiles";
export class TileBuilder {
    static SharedBuilder() {
        return new TileBuilder();
    }
    get metrics() {
        return this._m;
    }
    get namespace() {
        return this._ns ?? "";
    }
    withNamespace(namespace) {
        this._ns = namespace;
        return this;
    }
    withAddress(a) {
        this._a = a;
        return this;
    }
    withData(d) {
        this._d = d;
        return this;
    }
    withMetrics(metrics) {
        this._m = metrics;
        return this;
    }
    withType(type) {
        this._t = type;
        return this;
    }
    build() {
        const type = this._t ?? (Tile);
        const t = new type(this._a?.x || 0, this._a?.y || 0, this._a?.levelOfDetail || this._m?.minLOD || 0, this._d || null);
        if (this._m) {
            t.geoBounds = Tile.BuildEnvelope(t, this._m);
            t.boundingBox = Tile.BuildBounds(t, this._m);
        }
        return t;
    }
}
//# sourceMappingURL=tiles.builder.js.map